import * as path from "node:path";

import {
  exists,
  readJson,
  sha256Text,
  writeJson,
} from "../../common.js";
import type {
  Checkpointer,
  CheckpointRecord,
} from "./types.js";

function keyPath(dir: string, key: string): string {
  const digest = sha256Text(key);
  return path.join(dir, `${digest}.json`);
}

export function fileCheckpointer(dir: string): Checkpointer {
  return {
    read<T = unknown>(key: string): CheckpointRecord<T> | null {
      const p = keyPath(dir, key);
      if (!exists(p)) return null;
      return readJson<CheckpointRecord<T>>(p);
    },
    write<T = unknown>(record: CheckpointRecord<T>): void {
      writeJson(keyPath(dir, record.key), record);
    },
  };
}

export function noopCheckpointer(): Checkpointer {
  return {
    read(): null {
      return null;
    },
    write(): void {
      // intentionally empty
    },
  };
}
